"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { ExpandSideNavUserAvatarLoading } from '@autoguru/expand-side-nav';
import { CDN, RETAIL_URL, TENANT_NAME } from '@autoguru/global-configs';
import { AccountCircleClearIcon, BnplNewIcon, ClipboardCheckOutlineIcon, ClipboardFleetOutlineIcon, DollarCircleOutlineIcon, FeedIcon, HomeOutlineIcon, PencilEditIcon, QuoteRequestIcon, ResourcesIcon, StoreOutlineIcon, ToolOutlineIcon, TrainingGuidesIcon, UberBoxWhiteIcon, WarningIcon } from '@autoguru/icons';
import { tenantMap } from '@autoguru/tenant-selector';
import { decode, encode } from 'qss';
import { lazy, useCallback, useMemo } from 'react';
import { getOutstandingOnboardingActionsNum } from './getOutstandingOnboardingActionsNum';
import { jsx as _jsx } from "react/jsx-runtime";
const LoggedInUserAvatar = /*#__PURE__*/lazy(async () => import('@autoguru/expand-side-nav/ExpandSideNavLoggedInUserAvatar/ExpandSideNavLoggedInUserAvatar'));
const SPOutstandingOnboardingActionsCountBubble = /*#__PURE__*/lazy(async () => import('./SPOutstandingOnboardingActionsCountBubble'));
export const useSupplierPortalAsideItems = ({
  baseUrl: _baseUrl = '',
  supplierSlug
}) => {
  var _SPOutstandingOnboard;
  const OnboardingActionsCountBubble = () => _SPOutstandingOnboard || (_SPOutstandingOnboard = /*#__PURE__*/_jsx(SPOutstandingOnboardingActionsCountBubble, {
    supplierSlug: supplierSlug
  }));
  const resourceUrl = TENANT_NAME === 'nz' ? 'policies' : 'downloads';
  const checkSupplierSelected = useCallback(() => Promise.resolve(Boolean(supplierSlug)), [supplierSlug]);

  //This is temporary for the onboarding, we use it to hide menu items in nz tenant
  const checkTenant = useCallback(() => {
    return Promise.resolve(TENANT_NAME !== 'nz');
  }, []);
  return useMemo(() => {
    const locationParams = _objectSpread(_objectSpread({}, location.search.slice(1) ? decode(location.search.slice(1)) : {}), {}, {
      // Remove auth code from URL
      code: void 0,
      state: void 0
    });
    return {
      header: [{
        links: [{
          label: 'Complete your profile',
          icon: WarningIcon,
          iconColour: 'danger',
          to: `${_baseUrl}/complete-profile?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: async () => {
            const outstandingActions = await getOutstandingOnboardingActionsNum({
              supplierSlug
            });
            return outstandingActions > 0;
          },
          AuthedOverlay: OnboardingActionsCountBubble
        }]
      }],
      body: [{
        links: [{
          label: 'Home',
          icon: HomeOutlineIcon,
          to: `${_baseUrl}?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Bookings',
          icon: ClipboardCheckOutlineIcon,
          to: `${_baseUrl}/booking?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: checkTenant
        }, {
          label: 'Fleet Bookings',
          icon: ClipboardFleetOutlineIcon,
          to: `${_baseUrl}/fleet-booking?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Quote Requests',
          icon: QuoteRequestIcon,
          to: `${_baseUrl}/quote-request?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: checkTenant
        }, {
          label: 'BNPL',
          icon: BnplNewIcon,
          to: `${_baseUrl}/bnpl?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: checkTenant
        }, {
          label: 'Uber',
          icon: UberBoxWhiteIcon,
          to: `${_baseUrl}/uber-voucher?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: checkTenant
        }, {
          label: 'Quote a service',
          icon: PencilEditIcon,
          to: `${RETAIL_URL}/workshop/hl/quote-a-service?${encode({
            supplierSlug
          })}`,
          isLink: false,
          checkIsVisible: checkTenant
        }, {
          label: 'Account Details',
          icon: AccountCircleClearIcon,
          to: `${RETAIL_URL}/workshop/hl/account-details?${encode({
            supplierSlug
          })}`,
          isLink: false,
          checkIsVisible: checkSupplierSelected
        }, {
          label: 'Store',
          icon: StoreOutlineIcon,
          to: `${_baseUrl}/store?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Pricing',
          icon: DollarCircleOutlineIcon,
          to: `${_baseUrl}/pricing?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Jobs',
          icon: ToolOutlineIcon,
          to: `${_baseUrl}/job?${encode(_objectSpread({}, locationParams))}`,
          checkIsVisible: checkTenant
        },
        // {
        // 	label: 'Terminals',
        // 	icon: CreditCardWirelessIcon,
        // 	to: `${baseUrl}/terminal?${encode({
        // 		...locationParams,
        // 	})}`,
        // },
        {
          label: 'News',
          icon: FeedIcon,
          to: `${_baseUrl}/news?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Training Guides',
          icon: TrainingGuidesIcon,
          to: `${_baseUrl}/guide?${encode(_objectSpread({}, locationParams))}`
        }, {
          label: 'Resources',
          icon: ResourcesIcon,
          to: `${_baseUrl}/resource/${resourceUrl}?${encode(_objectSpread({}, locationParams))}`
        }]
      }],
      footer: [{
        links: [{
          label: tenantMap[TENANT_NAME].label,
          iconSrc: `${CDN}/images/tenant/icon/round/${tenantMap[TENANT_NAME].code}.svg`
          // to: `${SP_BASE_PATH}/global-tenant`, //Enable this when supplier legagy is fully migrate to /au
        }, {
          IfAuthedComponent: LoggedInUserAvatar,
          Component: ExpandSideNavUserAvatarLoading,
          fullWidth: true,
          ariaLabel: 'User account',
          to: `${_baseUrl}/account?${encode(_objectSpread({}, locationParams))}`
        }]
      }]
    };
  }, [_baseUrl, location.search, supplierSlug, OnboardingActionsCountBubble]);
};